import React, { Component, useState, useEffect, useContext } from 'react';
import styles from './DirectoryButtonArea.module.scss';
import DirectoryButton from './directory-button/DirectoryButton';
import { AppContext } from '../../context/AppContext';
import { DirectoryListType } from '../directory-list/DirectoryList';
import { DoctorIcon, HospitalIcon, PharmacyIcon, SearchIcon } from '../icons/Icons';

const DirectoryButtonArea = (props: any) => {
  const appContext = useContext(AppContext);
  let currentListType: DirectoryListType;

  switch (appContext.directoryListType) {
    case DirectoryListType.doctor:
      currentListType = DirectoryListType.doctor;
      break;
    case DirectoryListType.facility:
      currentListType = DirectoryListType.facility;
      break;
    case DirectoryListType.pharmacy:
      currentListType = DirectoryListType.pharmacy;
      break;
    case DirectoryListType.all:
      currentListType = DirectoryListType.all;
      break;
    default:
      currentListType = DirectoryListType.none;
      break;
  }

  return (
    <div className={styles.directoryButtonContainer}>
      <DirectoryButton buttonText={'Find a doctor'} buttonIndex={1} currentListType={currentListType} listType={DirectoryListType.doctor}>
        <DoctorIcon height="40px" width="40px" isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.doctor} />
      </DirectoryButton>
      <DirectoryButton buttonText={'Find a hospital, facility, or other service'} buttonIndex={2} currentListType={currentListType} listType={DirectoryListType.facility}>
        <HospitalIcon height="40px" width="40px" isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.facility} />
      </DirectoryButton>
      <DirectoryButton buttonText={'Find a pharmacy'} buttonIndex={3} currentListType={currentListType} listType={DirectoryListType.pharmacy}>
        <PharmacyIcon height="40px" width="40px" isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.pharmacy} />
      </DirectoryButton>
      <DirectoryButton buttonText={'Find by name or keyword'} buttonIndex={4} currentListType={currentListType} listType={DirectoryListType.all}>
        <SearchIcon height="40px" width="40px" isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.all} />
      </DirectoryButton>
    </div>
  );
};

export default DirectoryButtonArea;
